import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { SiteManagerComponent } from 'src/app/site-management/site-manager/site-manager.component';
import { BuildingManagementService } from 'src/app/building-managment/building-management.service';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { PageName } from 'src/app/shared/utils/user-roles';
import { FloorManagementService } from 'src/app/floor-management/floor-management.service';

@Component({
  selector: 'app-add-building',
  templateUrl: './add-building.component.html',
  styleUrls: ['./add-building.component.scss'],
})
export class AddBuildingComponent implements OnInit, OnDestroy {
  @Input() buildingsList: any = [];
  subscription: Subscription | undefined;
  dialogRef: MatDialog | undefined;
  sharedData: any;
  readonly LANG_CONST = LANG_CONST;
  CONSTANTS = CONSTANTS;
  PageName = PageName;
  @Output() buildingCreated = new EventEmitter<String>();

  constructor(
    private helperService: HelperService,
    public sharedDataService: SharedDataService,
    public buildingManagementService: BuildingManagementService,
    public floorManagementService: FloorManagementService
  ) {}

  ngOnInit(): void {
    this.sharedDataService.currentData.subscribe((sharedData) => {
      this.sharedData = sharedData;
    });
  }

  /**
   * @description ## openSiteModal method will open the modal dialog for add building,
   *              user can add building and their relevant floors. On afterClosed of
   *              this Modal edit Mode will set to false for buildingg and floors and
   *              emits the parent component about creation of building.
   * @returns { void }
   */

  openSiteModal(): void {
    const dialogInstance = this.helperService.openModalDialog(
      SiteManagerComponent,
      {
        enableBackOperation: false,
        defaultNavigation: CONSTANTS.BUILDING,
        noErrorToasterShow: true,
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );
    dialogInstance.afterClosed().subscribe(() => {
      this.sharedDataService.setEditMode({
        building: false,
        floor: false,
      });
      this.buildingCreated.emit();
    });
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  editSiteModal(): void {
    const dialogInstance = this.helperService.openModalDialog(
      SiteManagerComponent,
      {
        enableBackOperation: true,
        defaultNavigation: CONSTANTS.SITE,
        noErrorToasterShow: true,
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );
    dialogInstance.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.floorManagementService.setTriggerRerender(true);
      }
      this.buildingManagementService
        .getAllBuildingsBySiteId(
          this.sharedData?.selectedSite?.siteId,
          true,
          true
        )
        .subscribe({
          next: (res: any) => {
            this.buildingsList = res;
            if (this.buildingsList.length <= 0) {
              this.buildingManagementService.buildingsView = false;
            } else this.buildingManagementService.buildingsView = true;
          },
        });
    });
  }
}
